import React,{Component,createRef} from "react";
import SideBarContent from "./SideBarContent";
// import BreadCrumbs from "../UI/BreadCrumbs";
// import Icons from "../Icons/Icons";
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router';
import MainContainer from './MainContainer';
import {findPathById,formatPath,valueAssigntoVariable,checkAndAddProperties} from './HTMLBuilderfunction';
// import ViewPort from "../../hoc/ViewPort";
import { isSet,parameterizedURLAccessToken } from "../../Utils/CommonFunctions";
import PreviewHtml from "./PreviewHtml";
import RightSideBarContent from './RightSideBarContent';
import $ from 'jquery';
import * as properties from './elementsPropertiesItems';
import Buttons from "../../Components/UI/Buttons";
import Conditions from './Conditions';
import * as ShipConstants from '../../Global/Constants';
import BuilderHoc from "./BuilderHoc";
// import htmlToJson from 'html-to-json';
// import AceEditor from "react-ace";

const bodyUUID = 'body_'+uuidv4();
const initialContent = {
  id:bodyUUID,
  name:'div',
  type:'Body',
  data:'',
  children:[],
  attributes:{style:{width:'100%',padding:'10px 10px 10px 10px'}}
};
class HtmlBuilder extends Component {
  
  constructor(props) {
    super(props);
    this.state={
      activeTab:'LAYOUT',
      editorType:props.editorType,//'BUILDER',
      htmlContentItems:{
        ...initialContent
      },
      currentElement:{
        isShowProperties:false,
        id:bodyUUID,
        map:'.children',
        data:[],
      },
      isPreviewModal:false,
      activeTab:'ElementsToolbar',
      variableList:[],
      cursorPosition:0,
      showFilterOpen:false
    }
    this.myUploadRef = createRef();
  }
  componentDidMount = async ()=>{
    //this.setSelectedCurrentId(bodyUUID);
    if(this.props.pageFrom==='Email' || this.props.pageFrom==='PDF'){
      //console.log('componentDidMount === ', this.props.pageFrom)
      const {htmlContentData} = this.props.builderObject; 
      const {htmlBuilderObj} = htmlContentData;
      //if(this.props.builderObject.htmlContentData.htmlBuilderObj!==this.state.htmlContentItems){
        //console.log('ssssssssssss',htmlBuilderObj)
        if(htmlBuilderObj!==''){
          let currentElement = {
            ...this.state.currentElement,
            data:htmlBuilderObj.children,
            id:''
          }
          //this.setDestinationItems(htmlBuilderObj);
          this.setSelectedCurrentId(htmlBuilderObj.id);
          this.setState({htmlContentItems:htmlBuilderObj,currentElement:currentElement});
          //this.setSelectedCurrentId(htmlBuilderObj.id);
        }else{
          this.setState({htmlContentItems:{id:bodyUUID,
              name:'div',
              type:'Body',
              data:'',
              children:[],
              attributes:{style:{width:'100%',padding:'10px 10px 10px 10px'}}}})
        }        
      //}
    }
  }
  componentDidUpdate = (nextProps, prevProps)=>{    
    if(this.props.pageFrom==='Email' || this.props.pageFrom==='PDF' || this.props.pageFrom==='Domain'){
      if(nextProps.builderObject.isPreviewModalOpen!==this.props.builderObject.isPreviewModalOpen)
      //console.log('HtmlBuilder componentDidUpdate===',this.props.builderObject);
      this.setState({isPreviewModal:this.props.builderObject.isPreviewModalOpen})
    }
    if(this.props.convertedHtmldata!==prevProps.convertedHtmldata){
      console.log('this.props.convertedHtmldata',this.props.convertedHtmldata);
      // this.setDestinationItems()
    }


    if(this.props.pageFrom==='Email' || this.props.pageFrom==='PDF' || this.props.pageFrom==='Domain'  || this.props.pageFrom==='Manual Window'){
      const {htmlContentData} = this.props.builderObject; 
      const {htmlBuilderObj} = htmlContentData; 
      //console.log('htmlContentData===',htmlContentData)
      //console.log('htmlBuilderObj===',htmlBuilderObj)
      //let htmlContentItems = JSON.parse(htmlBuilderObj);
      //console.log('componentDidUpdate==',htmlContentItems)
      //console.log('aaaaaaaa111')
      if(nextProps.builderObject.htmlContentData.htmlBuilderObj!==this.state.htmlContentItems && nextProps.builderObject.htmlContentData.htmlBuilderObj!==''){
        //console.log('aaaaaaaa')
        if(htmlBuilderObj!==''){
          let currentElement = {
            ...this.state.currentElement,
            data:htmlBuilderObj.children,
            id:''
          }
          //this.setDestinationItems(htmlBuilderObj);
          this.setSelectedCurrentId(htmlBuilderObj.id);
          this.setState({htmlContentItems:htmlBuilderObj,currentElement:currentElement});
          //this.setSelectedCurrentId(htmlBuilderObj.id);
        }else{
          this.setState({htmlContentItems:{...initialContent}})
        }        
      }
      // else if(nextProps.builderObject.htmlContentData.htmlBuilderObj!==this.state.htmlContentItems && nextProps.builderObject.htmlContentData.htmlBuilderObj===''){
      //   let htmlObj = {
      //         id:bodyUUID,
      //         name:'div',
      //         type:'Body',
      //         data:'',
      //         children:[],
      //         attributes:{style:{width:'100%',padding:'10px 10px 10px 10px'}}
      //       }
      //   let curHtmlObj = {
      //             map:"",
      //             id:bodyUUID,
      //             isShowProperties:true,
      //             data:{...htmlObj}
      //           }        
      //   this.setState({htmlContentItems:JSON.parse(JSON.stringify(htmlObj)),currentElement:JSON.parse(JSON.stringify(curHtmlObj))})
      // }
       
    } 

  }
  updateTabDetails = (tabId='ElementsToolbar') => {
    this.setState({activeTab:tabId})
  }
 
  onFileChange =()=>{
      var inputField = this.myUploadRef;
      // inputField.click();
  }
  uploadImageFiles = (e)=> {
    // const files = e.target.files;
    // if(files.length > 0) {    
    //   this.props.Loader(true);
    //   Object.entries(files).map(([key, fileItem]) => {
    //     const formData = new FormData();            
    //     formData.append("upload_file", fileItem);
    //     const APIURL = 'files/upload';
    //     callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
    //     .then(res => {    
    //       if(res.status==200){                        
    //         const response = res.data;
    //       if(response.code===200){
    //         const responseData =  response.data;
    //         this.updateUploadedImage(responseData);
    //         }else{
    //         this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
    //         }                                                
    //       }else{
    //         this.props.Loader(false);
    //         this.props.failMessage('Something went wrong..');
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.props.Loader(false);
    //       this.props.failMessage('Something went wrong..');                    
    //     })
    //   })
    // }
  }

  showFilterContent = async (initial=false) => {
    //console.log('showFilterContent')
    if(initial === true){
      //console.log('sssssss')
      this.addRulesRow()
    }
    await this.setState({showFilterOpen:!this.state.showFilterOpen})
  }

  applyFilterContent = async () => {
      const {htmlContentItems,currentElement,activeTab} = this.state;
      let updateHtmlContent = htmlContentItems;
      let currentPath = null;
      let path = '';
      let key = 'data';

      if(activeTab==='BodyProperties'){
        currentPath = '';
      }else{
        if(currentPath==null){
          currentPath = currentElement.map;
        } 
      }
      updateHtmlContent = checkAndAddProperties(updateHtmlContent,currentPath+''+path,key);
      const getConditions = isSet(eval('updateHtmlContent'+currentPath+''+path+'.conditions'),'');
      //console.log('applyFilterContent===',getConditions)
      let conditionDataString = '';
      isSet(getConditions,[]).map((x,i)=>{
        let val = '';
        let operatorVal = '';
        if(x.fieldType === 'MultiSelect' || x.fieldType === 'PickList' || x.fieldType === 'MultiLookup') {
            val = x.values ? x.values : [];
        }else {
          if(x.values) {
            if(x.values[0]) {
            val=x.values[0].value;
            }else {
              val = "";
            }
          }
        }

        if(x.filterObject && x.filterObject.name){
          operatorVal =  x.filterObject.name;
        }

        let opVal = '==';
        if(operatorVal==='is not equal to'){
          opVal = '!==';
        }

        let logicOp = ' ||';
        if(x.logicalOperator==='AND'){
          logicOp = ' &&'
        }

        if(i===0){
          conditionDataString += '${'+x.rule+'} '+opVal+" '"+val+"'";
        }else{
          conditionDataString += logicOp+' ${'+x.rule+'} '+opVal+" '"+val+"'";
        }      
        //console.log('conditionDataString===',x.rule,operatorVal,val,conditionDataString)
      })

      //console.log('currentPath path key==',currentPath+''+path+'.'+key)
      const getElements = isSet(eval('updateHtmlContent'+currentPath+''+path+'.'+key),'');
      const uptVal = valueAssigntoVariable(getElements,conditionDataString);
      try{        
        eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal');
      }catch(e){
        // console.log('e',e);
      }

      if(activeTab==='BodyProperties'){
        this.setSelectedCurrentId(updateHtmlContent.id) 
      }      
      this.setDestinationItems(updateHtmlContent);
      this.setSelectedCurrentId(currentElement.id) 
      await this.setState({showFilterOpen:!this.state.showFilterOpen})
  }

  addRulesRow = () => {
    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;    

    let currentPath = null;
    let path = '';
    let key = 'conditions';

    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }
    updateHtmlContent = checkAndAddProperties(updateHtmlContent,currentPath+''+path,key);
    const getElements = isSet(eval('updateHtmlContent'+currentPath+''+path+'.'+key),'');
    

    let condArr = [...getElements];

    // { 
    //   rule: "", 
    //   fieldTypeId: "" ,
    //   tableDescriptorId : "",
    //   fieldFilter : [],
    //   fieldFilterId: "",
    //   ruleId : "",
    //   logicalOperator : "AND",
    //   ruleValueId : "",
    //   values : null,
    //   fieldType: "" ,
    //   filterObject: null,
    //   multiSelectOptions : [],
    //   lookupWindowName : null,
    //   absolute_window : '',
    //   absolute_window1 : '',
    // }

    const addRow =  {
        tableDescriptorId: "",
        is_custom_field :  false,
        absolute_window: "",
        absolute_window1: "",
        fieldTypeId: "",
        fieldFilterId: "",
        ruleId:"",
        values: [],
        logicalOperator: 'AND',
        lineNumber : 1,
        fieldFilter : [],
        subFilters : [],
        filterObject : null,
        fieldType : '',
        period : '',
        multiSelectOptions : [],
    }
    condArr.push(addRow)    

    const uptVal = valueAssigntoVariable(getElements,condArr);
    //console.log('uptVal===',uptVal)

    try{
      //console.log('trrrrrryyyyy','updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal')
      eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal');
    }catch(e){
      // console.log('e',e);
    }

    if(activeTab==='BodyProperties'){
      this.setSelectedCurrentId(updateHtmlContent.id) 
    }
    //this.setSelectedCurrentId(currentElement.id)
    this.setDestinationItems(updateHtmlContent);

  }


  /********** For condition ************/

  drillDownHandleConditionsInputChange = (fieldData, index) => {
    let {windowFields} = this.props.builderObject;
    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;
    let currentPath = null;
    let path = '';
    let key = 'conditions';

    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }
    
    //console.log('drillDownHandleConditionsInputChange',currentPath,path,key)
    const list = eval('updateHtmlContent'+currentPath+''+path+'.'+key); //[...conditionList];

    if(fieldData) {
        const fieldCount = fieldData.length;
        if(fieldCount > 0) {
            const obj = fieldData[fieldCount-1];
            console.log(obj);
            let absoluteWindow = '';
            if(fieldCount > 1) {
              fieldData.map((arr,i) => {
                  if(arr.system_window_name) {
                      //absoluteWindow += i === 0 ? arr.system_window_name : '.'+arr.system_window_name;
                      absoluteWindow += i === 0 ? arr.id : '.'+arr.id;
                  }
              })
            }

          const filterdata = obj.filters;
          const fieldType = obj.field_type;
          const fieldName = obj.field_name;
          const options = obj.options;
          const id = obj.id;
          const lookupName = obj.lookUpName;
          const fieldTypeId = obj.fieldTypeId;
          let optionsArr = [];
          if(options.length > 0) {
            options.map((arr,i) => {
              const value = {
                "value": arr.key,
                "label": arr.value,
              }
              optionsArr.push(value);
              return true;
            }) 
          }

            // const data = findFiltersByFieldId(value);
          list[index]['rule'] = fieldName;
          list[index]['fieldType'] = fieldType;
          list[index]['fieldTypeId'] = fieldTypeId;
          list[index]['fieldFilter'] = filterdata;
          list[index]['lookupWindowName'] = lookupName;
          list[index]['absolute_window'] = absoluteWindow;
          list[index]['absolute_window1'] = fieldData;
          // list[index]['system_absolute_window'] = system_absolute_window;
          if(obj.dependent_layout) {
            list[index]['lookupWindowNameId'] = obj.dependent_layout.window_id;
          }
    
    
          if(lookupName === 'Notes') {
              list[index]['lookupWindowName'] = windowFields.window_name;
              list[index]['lookupWindowNameId'] = windowFields.window_id;
              list[index]['isNotes'] = true;
          }else {
            list[index]['isNotes'] = false;
          }

          if(fieldType === 'User') {
              list[index]['lookupWindowName'] = "User";
              list[index]['lookupWindowNameId'] = ShipConstants.USERS_WINDOW_FIELD_ID;
          }

          if(filterdata && filterdata.length > 0) {
            if(filterdata[0].name === 'is changed') {
              list[index]['fieldFilterId'] = filterdata[1].filterId;
              list[index]['filterObject'] = filterdata[1];
            }else {
              list[index]['fieldFilterId'] = filterdata[0].filterId;
              list[index]['filterObject'] = filterdata[0];
            }
          }


          let valArr = [];
          if(fieldType === 'MultiSelect'){
            valArr = [{lineNumber:index,value:''}]
          }
          
          list[index]['values'] = valArr;
          list[index]['multiSelectOptions'] = optionsArr;
          list[index]['tableDescriptorId'] = id;
          //console.log('list===',list)
          //setConditionList(list);  
          try{
            //console.log('trrrrrryyyyy','updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal')
            eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=list');
          }catch(e){
            // console.log('e',e);
          }

          if(activeTab==='BodyProperties'){
            this.setSelectedCurrentId(updateHtmlContent.id) 
          }
          //this.setSelectedCurrentId(currentElement.id)
          this.setDestinationItems(updateHtmlContent);          
        }
    }else {
      list[index]['rule'] = '';
      list[index]['fieldType'] = '';
      list[index]['fieldTypeId'] = '';
      list[index]['fieldFilter'] = [];
      list[index]['lookupWindowName'] = null;
      list[index]['absolute_window'] = '';
      list[index]['absolute_window1'] = '';
      list[index]['lookupWindowNameId'] = '';
      list[index]['fieldFilterId'] = '';
      list[index]['filterObject'] = null;
      
      list[index]['values'] = [];
      list[index]['multiSelectOptions'] = [];
      list[index]['tableDescriptorId'] = '';
      //setConditionList(list);
      try{
        //console.log('trrrrrryyyyy','updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal')
        eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=list');
      }catch(e){
        // console.log('e',e);
      }

      if(activeTab==='BodyProperties'){
        this.setSelectedCurrentId(updateHtmlContent.id) 
      }
      //this.setSelectedCurrentId(currentElement.id)
      this.setDestinationItems(updateHtmlContent);
    }
  }


  selectChangeHandler = (value,name,type,index,optionsArr,fieldType="ddd") => {
    let {windowFields} = this.props.builderObject;
    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;
    let currentPath = null;
    let path = '';
    let key = 'conditions';

    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }

    const list = eval('updateHtmlContent'+currentPath+''+path+'.'+key);  
    if(name === 'fieldFilterId') {
      const data = this.findFiltersOjectByFilterIdAndFilterArray(value, list[index]['fieldFilter']);
      if(data.has_multiple_input === 'true'  || data.has_multiple_input === true) { 
        list[index]['values'] = [];
        list[index]['values'][0] = {value:''};
        list[index]['values'][1] = {value:''};
      }else {

        
        //console.log('datadata==',data)
        let valCond = null;
        if(fieldType === 'MultiSelect' && data.name!=='is empty'){
          valCond = [{lineNumber:index,value:''}]
        }
        list[index]['values'] = valCond;
        
        //list[index]['values'] = null;
      }
      list[index]['filterObject'] = data;
      list[index][name] = value;
    }else if(name === 'lookupValues') {
      list[index]['values'] = [{
        value : value
      }];
    }else {
      list[index][name] = value;  
    }
    
    try{      
      eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=list');
    }catch(e){
      // console.log('e',e);
    }

    if(activeTab==='BodyProperties'){
      this.setSelectedCurrentId(updateHtmlContent.id) 
    }    
    this.setDestinationItems(updateHtmlContent);
  }

  // handle input change
  handleConditionsMultiSelectInputChange = (selectedOption, index) => {
    let {windowFields} = this.props.builderObject;
    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;
    let currentPath = null;
    let path = '';
    let key = 'conditions';

    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }
    const list = eval('updateHtmlContent'+currentPath+''+path+'.'+key);      
    list[index]['values'] = selectedOption; 
    try{      
      eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=list');
    }catch(e){
      // console.log('e',e);
    }

    if(activeTab==='BodyProperties'){
      this.setSelectedCurrentId(updateHtmlContent.id) 
    }    
    this.setDestinationItems(updateHtmlContent);    
  }

  // handle input change
  handleCondiotnOperandInputChange = (e, index) => {
    const { name, value } = e.target;
    let {windowFields} = this.props.builderObject;
    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;
    let currentPath = null;
    let path = '';
    let key = 'conditions';

    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }
    const list = eval('updateHtmlContent'+currentPath+''+path+'.'+key);         
    list[index]['logicalOperator'] = value; 
    try{      
      eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=list');
    }catch(e){
      // console.log('e',e);
    }

    if(activeTab==='BodyProperties'){
      this.setSelectedCurrentId(updateHtmlContent.id) 
    }    
    this.setDestinationItems(updateHtmlContent); 
  }

  handleConditionsRemoveClick = (index) => {
    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;
    let currentPath = null;
    let path = '';
    let key = 'conditions';

    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }
    const list = eval('updateHtmlContent'+currentPath+''+path+'.'+key); 

    
    list.splice(index, 1);
    
    try{      
      eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=list');
    }catch(e){
      // console.log('e',e);
    }

    if(activeTab==='BodyProperties'){
      this.setSelectedCurrentId(updateHtmlContent.id) 
    }    
    this.setDestinationItems(updateHtmlContent); 
  }

  findFiltersOjectByFilterIdAndFilterArray = (filterId, filterArray) => {
    let data = [];
    if(filterArray) {
      filterArray.map((arr,i) => {
        if(arr.filterId === filterId) {
          data = arr;
        }
      })
    }
    return data;
  }

  /********** For condition end ************/

  
  
  render(){
    const {currentElement,htmlContentItems,isPreviewModal,variableList,activeTab} = this.state;
    console.log('currentElement==',currentElement)
    let breadCrumbs =   this.getAndSetBreadCrumbs();
    if(this.props.pageFrom==='Manual Window'){
      breadCrumbs =   this.getAndSetBreadCrumbsForManualWindow();
    }

    if(this.props.pageFrom==='Email' || this.props.pageFrom==='PDF'){
      let getBreadCrumbsList = this.props.builderObject.breadCrumbsList;
      let buttonList = [];
      isSet(getBreadCrumbsList.buttonList,[]).map((item,index)=>{
        let buttonObj = {
          ...item
        }
        if(item.name === 'Save'){
          buttonObj = {
            ...item,
            clickHandler:this.saveHTMLBuilderHandler
          }
        }
        buttonList.push(buttonObj)
      })

      //console.log('buttonList===',buttonList)
      breadCrumbs = {
        ...getBreadCrumbsList,
        buttonList:buttonList
      }
    }


    let actionBtn = [];
    if(this.props.pageFrom==='Domain'){
      let getBreadCrumbsList = this.props.builderObject.actionBtn[0];
      let list = [];
      isSet(getBreadCrumbsList.list,[]).map((item,index)=>{
        let buttonObj = {
          ...item
        }
        if(item.type === 'Save'){
          buttonObj = {
            ...item,
            clickHandler:this.saveHTMLBuilderHandler
          }
        }
        list.push(buttonObj)
      })
      //console.log('list===',list)
      actionBtn = [...this.props.builderObject.actionBtn];
      actionBtn[0]['list'] = list;
      //console.log('actionBtn===',actionBtn)
    }
    

    const viewTypes= [
      {
        svgIcon:'MobileIcon',
      },
      {
        svgIcon:'DesktopIcon'
      }
    ];

    const {htmlContentData} = this.props.builderObject;
    let builderObject = {
      ...this.props.builderObject,
      insertTextHandler:this.insertTextHandler
    }
    // console.log('builderObject==',builderObject)
    // console.log('htmlContentItems==',htmlContentItems)
    //console.log('htmlContentItems string==',JSON.stringify(htmlContentItems));
    //console.log('this.props.pageFrom==',this.props.pageFrom)
    console.log('breadCrumbs==',this.props.tabList)
    return(
      <>      
            {
              this.props.pageFrom === 'Domain'?
              <div className="view  view-xl">
                <div className="view view--hor-scroll">
                  <div className="card_Box">
                    <div className="row">
                      <div className="col-12 " ref={this.props.builderObject.refAtt}>
                        <div className="card mb-0">

                          <div className="card-header p-2">
                            <div className="card-title">
                              <div className="mx-auto">
                                <div className="material-switch p-2">
                                  <span className="mr-4">Is Active Login</span>
                                  <input id="custom_login"
                                    name="is_custom_login_active"
                                    type="checkbox"
                                    checked={(htmlContentData.is_custom_login_active) === true ? true : false}
                                    onChange={(e) => this.props.builderObject.onChangeHandler(e)}
                                  />
                                  <label htmlFor="custom_login" className="secondary_bg"></label>
                                  <div className="float-right">                                     
                                    <Buttons buttonList={actionBtn} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> 
                          
                          <div className="card-body pb-0">
                            <div className="d-flex">
                              <div className="w-100 pr-1 mr-1">
                                
                                <div className="d-flex dataTables_wrapper" style={{bottom:'0px',top:'0px',width:'100%'}}>
                                  <SideBarContent 
                                    htmlContentItems={htmlContentItems}
                                    setDestinationItems={this.setDestinationItems}
                                    setSelectedCurrentId={this.setSelectedCurrentId}
                                    onChangePropertiesHandler={this.onChangePropertiesHandler}
                                    currentElement={currentElement} 
                                    uploadFileRef={this.myUploadRef}
                                    fileChangeHandler={this.onFileChange}
                                    fileClickHandler={this.uploadImageFiles}
                                    updateTabDetails={this.updateTabDetails}  
                                    activeTab={activeTab} 
                                    pageFrom={isSet(this.props.pageFrom,'Self')==='Self'?'Self':this.props.pageFrom}                                   
                                  />
                                  <div className="view view-xl">
                                    <PreviewHtml 
                                      //htmlContentItems={htmlContentItems}
                                      htmlContentItems={JSON.parse(JSON.stringify(htmlContentItems))}
                                      viewTypes={viewTypes}
                                      onToogleHandlerPreview={isSet(this.props.pageFrom,'Self')==='Self'?this.onToogleHandlerPreview:this.props.builderObject.previewModaltoggleHandler}
                                      //isPreviewModal={isSet(this.props.pageFrom,'Self')==='Self'?isPreviewModal:this.props.builderObject.isPreviewModalOpen} 
                                      isPreviewModal={isPreviewModal}
                                    />
                                    <div className="table_Body d-flex align-items-center justify-content-center">
                                      <div className="content-left ">
                                        <div className="card">
                                          <MainContainer 
                                            htmlContentItems={this.state.htmlContentItems}
                                            handleDrop={this.handleDrop}
                                            setDestinationItems={this.setDestinationItems}
                                            currentElement={currentElement}
                                            onChangePropertiesHandler={this.onChangePropertiesHandler}
                                            setSelectedCurrentId={this.setSelectedCurrentId}
                                            handleDragEnd={this.handleDragEnd} 
                                            deleteElements={this.deleteElements}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                 
                              </div>
                            </div>
                          </div>

                        </div> 
                      </div>
                    </div>  
                  </div>
                </div>
              </div>
              :
              <BuilderHoc 
                // styles={this.props.pageFrom === 'Manual Window'?{top:'0px',left:'0px'}:{}}
                breadCrumbs={breadCrumbs}
                viewTypes={viewTypes}
                tabList={this.props.tabList}
                editorType={this.props.editorType}
                htmlContentItems={isSet(this.state.htmlContentItems.children,[])}
                convertAndCreateElementToHTML={this.convertAndCreateElementToHTML}
                toogleEditorTypeHandler={this.props.toogleEditorTypeHandler}
                pageFrom={this.props.pageFrom}
                setRenderData={this.setDestinationItems}
                >
                  <>
                  <div className="  view--hor-scroll filters-v3 view-xl" style={{}}>
                    <div className="d-flex dataTables_wrapper" style={{bottom:'0px',position:'absolute',top:'0px',width:'100%'}}>
                      <SideBarContent 
                        htmlContentItems={htmlContentItems}
                        setDestinationItems={this.setDestinationItems}
                        setSelectedCurrentId={this.setSelectedCurrentId}
                        onChangePropertiesHandler={this.onChangePropertiesHandler}
                        currentElement={currentElement} 
                        uploadFileRef={this.myUploadRef}
                        fileChangeHandler={this.onFileChange}
                        fileClickHandler={this.uploadImageFiles}
                        updateTabDetails={this.updateTabDetails}  
                        activeTab={activeTab}
                        pageFrom={isSet(this.props.pageFrom,'Self')==='Self'?'Self':this.props.pageFrom}  
                        showFilterContent={this.showFilterContent}                                  
                      />
                      <div className="view view-xl">
                        <PreviewHtml 
                          //htmlContentItems={htmlContentItems}
                          htmlContentItems={JSON.parse(JSON.stringify(htmlContentItems))}
                          viewTypes={viewTypes}
                          onToogleHandlerPreview={isSet(this.props.pageFrom,'Self')==='Self'?this.onToogleHandlerPreview:this.props.builderObject.previewModaltoggleHandler}
                          //isPreviewModal={isSet(this.props.pageFrom,'Self')==='Self'?isPreviewModal:this.props.builderObject.isPreviewModalOpen} 
                          isPreviewModal={isPreviewModal}
                        />
                        <div className="table_Body d-flex align-items-center justify-content-center">
                          <div className="content-left ">
                            <div className="card">
                              <MainContainer 
                                htmlContentItems={this.state.htmlContentItems}
                                handleDrop={this.handleDrop}
                                setDestinationItems={this.setDestinationItems}
                                currentElement={currentElement}
                                onChangePropertiesHandler={this.onChangePropertiesHandler}
                                setSelectedCurrentId={this.setSelectedCurrentId}
                                handleDragEnd={this.handleDragEnd} 
                                deleteElements={this.deleteElements}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <RightSideBarContent 
                        insertTextHandler={this.insertTextHandler}
                        builderObject={isSet(builderObject,{})}
                        pageFrom={this.props.pageFrom}
                      /> 
                    </div> 
                  </div>
                  
                </>
                   
                
                

              </BuilderHoc>
            }

            
            {
              this.props.pageFrom === 'Manual Window'?
              <Conditions 
                showFilterOpen={this.state.showFilterOpen} 
                showFilterContent={this.showFilterContent}
                currentElement={currentElement}
                htmlContentItems={this.state.htmlContentItems}
                windowFields={this.props.builderObject.windowFields}
                drillDownHandleConditionsInputChange={this.drillDownHandleConditionsInputChange}
                selectChangeHandler={this.selectChangeHandler}
                handleConditionsMultiSelectInputChange={this.handleConditionsMultiSelectInputChange}
                handleCondiotnOperandInputChange={this.handleCondiotnOperandInputChange}
                failMessage={this.props.builderObject.failMessage}
                Loader={this.props.builderObject.Loader}
                applyFilterContent={this.applyFilterContent}
                addRulesRow={this.addRulesRow}
                handleConditionsRemoveClick={this.handleConditionsRemoveClick}
              />
              :
              <></> 
            } 
          
      </>
    )
  }
  getAndSetBreadCrumbs = (params)=>{
    let backHistory = [];
    return {
      backHistory : [...backHistory],
      pageTitle:"HTML Builder",
      buttonList:[
        {
          name:"Preview",
          clickHandler:()=>this.onToogleHandlerPreview(),
          attributes:{
            className:"btn secondary_bg filterToggle mr-1",
          }
        },
      {
        name:"Save & Close",
        clickHandler:()=>{},
        attributes:{
          className:"btn secondary_bg  mr-1",
        }
      },{
        name:"Save",
        type:"Save",
        clickHandler:()=>{},
        attributes:{
          className:"btn primary_bg",
        }
      },
      
      ]
    }
  }

  getAndSetBreadCrumbsForManualWindow = () => {
    const params = this.props.match.params;
    return {
      backHistory : [{
        href : "/settings",
        name:"Settings"
        },
        {
        href : "/settings/windows",
        name:"Windows"
        },{
          href : "/settings/"+params.windowName+"/"+params.windowId+"",
          name:""+params.windowName+""
        }],
      pageTitle:"HTML Builder",
      buttonList:[
        {
          name:"Preview",
          clickHandler:()=>this.onToogleHandlerPreview(),
          attributes:{
            className:"btn secondary_bg filterToggle mr-1",
          }
        },
        {
          name:"Cancel",
          clickHandler:()=>this.clearHtmlContentItems(),
          attributes:{
            className:"btn secondary_bg  mr-1",
          }
        },
        {
          name:"Apply",
          type:"Save",
          clickHandler:()=>this.saveHTMLBuilderHandler(),
          attributes:{
            className:"btn primary_bg",
          }
        },
      
      ]
    }
  }

  clearHtmlContentItems = async () => {
    const {htmlContentItems,currentElement,activeTab} = this.state;
    const updateHtmlContent = htmlContentItems; //JSON.parse(JSON.stringify(htmlContentItems)) //{...htmlContentItems};
    let htmlObj = {
              id:bodyUUID,
              name:'div',
              type:'Body',
              data:'',
              children:[],
              attributes:{style:{width:'100%',padding:'10px 10px 10px 10px'}}
            }
    let curHtmlObj = {
              map:".children",
              id:"",
              isShowProperties:true,
              data:[]//{...htmlObj}
            }

    let childCount = updateHtmlContent.children;          
    const newDestinationItems = eval('updateHtmlContent.children');  
    newDestinationItems.splice(0);
    await this.setDestinationItems(updateHtmlContent);
    await this.setSelectedCurrentId(bodyUUID);

    // try{
    //   //console.log('trrrrrryyyyy','updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal')
    //   eval('updateHtmlContent.childen=[]');
    // }catch(e){
    //   // console.log('e',e);
    // }
    // // if(activeTab==='BodyProperties'){
    // //   this.setSelectedCurrentId(updateHtmlContent.id) 
    // // }
    // //await this.clearCurrentData(htmlObj)
    // this.setDestinationItems(updateHtmlContent);
    // await this.setState({
    //   //htmlContentItems:JSON.parse(JSON.stringify(htmlObj)),
    //   currentElement:JSON.parse(JSON.stringify(curHtmlObj))
    // })
    await this.props.builderObject.closeHTMLBuilder();
  }

  clearCurrentData = async (htmlObj) => {
    await this.setState({
      currentElement:{
        map:"",
        id:bodyUUID,
        isShowProperties:true,
        data:{...htmlObj}
      }}
    );
  }

  onToogleHandlerPreview = ()=>{
    this.setState({isPreviewModal:!this.state.isPreviewModal});
  }

  setSelectedCurrentId = async (id,isToogleActionAlone=false)=>{
    const {htmlContentItems,currentElement,activeTab} = this.state;
    const updateHtmlContent = {...htmlContentItems};
    let path = findPathById(htmlContentItems,isSet(id,bodyUUID));
    if(this.props.pageFrom === 'Email' || this.props.pageFrom === 'PDF'  || this.props.pageFrom === 'Domain'  || this.props.pageFrom === 'Manual Window'){      
      path = findPathById(htmlContentItems,isSet(id,htmlContentItems.id));
    } 

    console.log('path==',path)
    //console.log('setSelectedCurrentId path==',path,id,htmlContentItems,isToogleActionAlone)
    // console.log('jsonPath',id,formatPath(path),htmlContentItems);

    if(activeTab === 'BodyProperties'){
      path = '';
    }

    if(isToogleActionAlone===true){
      await this.setState({
        currentElement:{
          ...currentElement,
          isShowProperties:false,
        }}
      );
    }else{
      await this.setState({
        currentElement:{
          map:formatPath(path),
          id:id,
          isShowProperties:true,
          data:eval('updateHtmlContent'+formatPath(path))
        }}
      );
    }
    
    // console.log('currentElement',this.state.currentElement);
  }
   
  setDestinationItems = (items)=>{
    this.setState({htmlContentItems:items});
  }
  
  handleDrop = async (event, index) => {
    event.preventDefault();
    const {htmlContentItems,currentElement} = this.state;
    let updateHtmlContent = htmlContentItems;
    const receivedItemJSON  = event.dataTransfer.getData('element');
    var item = JSON.parse(receivedItemJSON);

    let childCount = updateHtmlContent.children;
    
    const elmtId = uuidv4();
    const updateItem = {
      id:elmtId,
      type:item.type,
      data:'',
      ...item,
      children:isSet(item.children,[]).map((child)=>{
        return{
          ...child,
          id:uuidv4(),
        }
      })
    };
    let contentMap = isSet(currentElement.map,'');
    //console.log('HAEcurrentElement',updateItem);
    //console.log('contentMap11',contentMap,index);
    const newDestinationItems = eval('updateHtmlContent'+contentMap);
    //console.log('contentMap22',newDestinationItems,contentMap);
    newDestinationItems.splice(childCount.length, 0, updateItem);
    // eval('updateHtmlContent'+contentMap+'='+'newDestinationItems');
    await this.setDestinationItems(updateHtmlContent);
    await this.setSelectedCurrentId(elmtId);
  }

  handleDragEnd = (result,colIndex) => {
    const {htmlContentItems,currentElement} = this.state;
    let destinationItems = htmlContentItems
    if (!result.destination) return; // Dropped outside of any droppable area
  
    const sourceDroppableId = result.source.droppableId;
    const destinationDroppableId = result.destination.droppableId;
  
    if (sourceDroppableId === destinationDroppableId) {
      // Reorder items within the same container
      //console.log('destinationItems===',destinationItems)
      //const reorderedItems = Array.from(destinationItems);
      const reorderedItems = destinationItems.children;
      //console.log('reorderedItems1111===',reorderedItems);
      // console.log('reorderedItems',reorderedItems);
      const [removed] = reorderedItems.splice(result.source.index, 1);
      reorderedItems.splice(result.destination.index, 0, removed);
      
      console.log('reorderedItems===',reorderedItems)
      destinationItems = {
        ...destinationItems,
        reorderedItems
      }
      this.setDestinationItems(destinationItems);
      this.setSelectedCurrentId(currentElement.id);
    } else {
      // The item was dropped into a different container
      // const colIndex = 0;
      if (destinationDroppableId === "gridDestination_" + colIndex) {
      //   // Item was dropped in an inner container, handle it here.
      //   // Prevent reordering and further processing.
        return;
      }
  
      // Item was dropped in the parent container; handle it here.
      // You can put your logic here for handling drops in the parent container.
    }
  };

  onChangePropertiesHandler = (path,key,val,currentPath=null,e,isInsert=false)=>{
    console.log('onChangePropertiesHandler==',path,key,val,currentPath)

    //console.log('window.getSelection().getRangeAt(0).startOffset==111',window.getSelection().getRangeAt(0).startOffset)    
    // let textToInsert = '{Insertion done}';
    let cursorPosition = -1; 
    if(isInsert === true){ cursorPosition = window.getSelection().getRangeAt(0).startOffset; this.setState({cursorPosition:cursorPosition}) }
    //   let textBeforeCursorPosition = e.currentTarget.textContent.substring(0, cursorPosition)
    //   let textAfterCursorPosition = e.currentTarget.textContent.substring(cursorPosition, e.currentTarget.textContent.length)
    //   console.log('insertGroupTextHandler==',cursorPosition,textBeforeCursorPosition,textAfterCursorPosition)
    //   e.currentTarget.textContent = textBeforeCursorPosition + textToInsert + textAfterCursorPosition
    //   console.log('e.currentTarget.textContent',e.currentTarget.textContent)

    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;


    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }



    
    // console.log('path,key,val',currentPath,'-',path,'-',key,'-',val);
    //console.log('checkAndAddProperties===',currentPath,path,key,this.state.activeTab)
    updateHtmlContent = checkAndAddProperties(updateHtmlContent,currentPath+''+path,key);
    //console.log('updateHtmlContent',updateHtmlContent,currentPath);
    const getElements = isSet(eval('updateHtmlContent'+currentPath+''+path+'.'+key),'');
    //console.log('currentPath path key==',currentPath+'||'+path+'@@'+key)
    const uptVal = valueAssigntoVariable(getElements,val);
    // console.log(eval('updateHtmlContent'+currentPath+''+path));
    //console.log(getElements,uptVal,'updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal');
   
    try{
      //console.log('trrrrrryyyyy','updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal')
      eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal');
    }catch(e){
      // console.log('e',e);
    }
   

    // let updateProperties = isSet(currentElement.data,{});
    // updateProperties = {
    //     ...updateProperties,
    //     [key]:val
    // };
    // console.log('key,val',updateHtmlContent,getElements,currentElement.map,path,key,val);
    // eval('updateHtmlContent'+currentElement.map+'='+'updateProperties');
    // console.log('key,val',updateHtmlContent);
    // console.log('updateProperties',updateHtmlContent,currentElement.map);

    if(activeTab==='BodyProperties'){
      this.setSelectedCurrentId(updateHtmlContent.id) 
    }
    //this.setSelectedCurrentId(currentElement.id)
    this.setDestinationItems(updateHtmlContent);
  }

  deleteElements = () => {
    const {htmlContentItems,currentElement,activeTab} = this.state;
    let updateHtmlContent = htmlContentItems;
    let currentPath = null;
    if(activeTab==='BodyProperties'){
      currentPath = '';
    }else{
      if(currentPath==null){
        currentPath = currentElement.map;
      } 
    }

    var lastChildrenIndexString = currentPath.substr(currentPath.length - 3);
    let newPath = currentPath.slice(0,-3);
    var lastChildrenIndex = lastChildrenIndexString.replace(/[^0-9]/g, '');
    //console.log('updateHtmlContent'+newPath)
    let dat = eval('updateHtmlContent'+newPath);
    dat.splice(lastChildrenIndex, 1); 

    // let uptVal = '';
    // console.log('updateHtmlContent'+currentPath+'=uptVal')
    // eval('updateHtmlContent'+currentPath+'=uptVal');
    if(activeTab==='BodyProperties'){
      this.setSelectedCurrentId(updateHtmlContent.id) 
    }    
    this.setDestinationItems(updateHtmlContent);
  }


  insertTextHandler = (content, type, dependentWindowName='') => {      
      let textToInsert = '';
      let textToInsertWithoutBrace = '';
      if(type === 'img') {
        textToInsert = content;
        textToInsertWithoutBrace = content;
      }else {
        if(dependentWindowName !== '') {
          textToInsert = '${'+dependentWindowName+'.'+content+'}';
          //textToInsertWithoutBrace = dependentWindowName+'.'+content;
          textToInsertWithoutBrace = content;
        }else {
          textToInsert = '${'+content+'}';                  
          textToInsertWithoutBrace = content;          
        }
      }
      
      let currentPath = null;
      let path = '';
      let key = 'data';

      //console.log('window.getSelection().getRangeAt(0).startOffset==222',window.getSelection().getRangeAt(0).startOffset,this.state.cursorPosition) 
      let cursorPosition = this.state.cursorPosition;
      const {htmlContentItems,currentElement,activeTab} = this.state;
      let updateHtmlContent = htmlContentItems;


      if(activeTab==='BodyProperties'){
        currentPath = '';
      }else{
        if(currentPath==null){
          currentPath = currentElement.map;
        } 
      }
      let elType = currentElement.data.type;
      if(elType === 'Text' || elType === 'Heading' || elType === 'SCM:INPUT'  || elType === 'SCM:OUTPUT'){
          let val = currentElement.data.data;
          let textBeforeCursorPosition = val.substring(0, cursorPosition)
          let textAfterCursorPosition = val.substring(cursorPosition, val.length)
          val = textBeforeCursorPosition + textToInsert + textAfterCursorPosition;

          if(elType === 'SCM:INPUT' || elType === 'SCM:OUTPUT'){
            val = textToInsertWithoutBrace; 
          }

          updateHtmlContent = checkAndAddProperties(updateHtmlContent,currentPath+''+path,key);
          const getElements = isSet(eval('updateHtmlContent'+currentPath+''+path+'.'+key),'');
          const uptVal = valueAssigntoVariable(getElements,val);
          //console.log('uptVal111===',uptVal,currentPath,path,key)
          try{
            eval('updateHtmlContent'+currentPath+''+path+'.'+key+'=uptVal');
          }catch(e){
            // console.log('e',e);
          }
          if(activeTab==='BodyProperties'){
            this.setSelectedCurrentId(updateHtmlContent.id) 
          }    
          this.setDestinationItems(updateHtmlContent);
      }else{
        this.props.builderObject.failMessage('Elements like TEXT, HEADING components only allowed!!!')
      }
      

  }

  saveHTMLBuilderHandler = () => {
    const {htmlContentItems} = this.state;
    let returnData = '';
    const createHTMLElements  = this.convertAndCreateElementToHTML(htmlContentItems.children,returnData);
    // console.log('createHTMLElements===',createHTMLElements)
    this.props.builderObject.saveFromHTMLBuilder(createHTMLElements,htmlContentItems);
  }

  convertAndCreateElementToHTML = (htmlElement,returnData='')=>{
    const {htmlContentItems} = this.state;
    let notAllowingTagReplacement = {'html':'manualhtml','meta':'manualheta','title':'manualtitle','script':'manualscript'};
    let notAllowingTag = ['html','meta','title','script'];
    // let returnData = [];
    htmlElement.map((item,itemIndex)=>{
          const {children} = item;
          const attribs = (item.hasOwnProperty('attributes')===true)?item.attributes:{};
          let attributes ={
            ...attribs,
            data:isSet(item.data,[]),
            id:isSet(htmlContentItems.id,itemIndex)
          }
          let tagName   = (item.hasOwnProperty('name')===true)?item.name:'';
          if(notAllowingTag.indexOf(tagName)!==-1){
            tagName = notAllowingTagReplacement[tagName];
          }
          let styleProp = '';
          console.log('tag',tagName)
          switch (tagName) {
              case "img":
                if(Object.keys(attributes.style).length !== 0 ){
                  Object.keys(attributes.style).map((key,i)=>{
                    let keyOri = isSet(properties.StyleAttributesOriginal[key],key);
                    styleProp +=  keyOri+':'+attributes.style[key]+';' 
                    //console.log('val==',val,'label===',lab)
                    //console.log('styleProp==',styleProp)
                  })
                }
                const src = (isSet(attributes.src,null)===null)?'/assets/img/temp-banner.png':parameterizedURLAccessToken(attributes.src);
                returnData+=`<div style="{${styleProp}}"><${tagName} width="${attributes.width}" height="${attributes.height}" src="${src}" /></div>`;
                return returnData;
                // return React.createElement(tagName, {...attributes,src:src});
              case "scm:inputtext":
                returnData+=`<div><${tagName} name="${attributes.data}" /></div>`;
                return returnData;
              case "scm:outputtext":
                returnData+=`<div><${tagName} name="${attributes.data}" /></div>`;
                return returnData;
              case "scm:dataTable":
                let varText = '';
                let entriesText = '';
                if(attributes.entries!==''){ entriesText = `entries="${attributes.entries}"` }
                if(attributes.var!==''){ varText = `var="${attributes.var}"` }
                if(children.length===0){
                  returnData+=`<${tagName} ${entriesText} ${varText}></${tagName}>`;
                  return returnData;
                }else{
                  returnData+=`<${tagName} ${entriesText} ${varText}>${this.convertAndCreateElementToHTML(children)}</${tagName}>`;
                  return returnData;
                }
              case "scm:decision":
                if(children.length===0){
                  returnData+=`<${tagName}></${tagName}>`;
                  return returnData;
                }else{
                  returnData+=`<${tagName}>${this.convertAndCreateElementToHTML(children)}</${tagName}>`;
                  return returnData;
                }
              case "scm:if":
                if(children.length===0){
                  returnData+=`<${tagName} condition="${attributes.data}"></${tagName}>`;
                  return returnData;
                }else{
                  returnData+=`<${tagName} condition="${attributes.data}">${this.convertAndCreateElementToHTML(children)}</${tagName}>`;
                  return returnData;
                }
              case "scm:elseIf":
                if(children.length===0){
                  returnData+=`<${tagName} condition="${attributes.data}"></${tagName}>`;
                  return returnData;
                }else{
                  returnData+=`<${tagName} condition="${attributes.data}">${this.convertAndCreateElementToHTML(children)}</${tagName}>`;
                  return returnData;
                } 
              default:
                if(children.length===0){
                  console.log('attributes===',attributes.style)                  
                  if(Object.keys(attributes.style).length !== 0 ){
                    Object.keys(attributes.style).map((key,i)=>{
                      let keyOri = isSet(properties.StyleAttributesOriginal[key],key);
                      styleProp +=  keyOri+':'+attributes.style[key]+';' 
                      //console.log('val==',val,'label===',lab)
                      //console.log('styleProp==',styleProp)
                    })
                  }
                  returnData+=`<${tagName} style="${styleProp}">${isSet(item.data,'')}</${tagName}>`;
                  return returnData;
                  // return React.createElement(tagName, {...attributes},isSet(item.data,''));
                }else{
                  returnData+=`<${tagName} style="${styleProp}">${this.convertAndCreateElementToHTML(children)}</${tagName}>`;
                  return returnData;
                  // return React.createElement(tagName, {...attributes}, this.convertAndCreateElement(children));
                }
          }
    })
    return returnData;
     
  }



}

HtmlBuilder.defaultProps = {
  componentType:'GENERAL',
}
export default withRouter(HtmlBuilder);